import { message, notification } from 'antd'
import { merge } from 'lodash'

import { ApplicationType } from '@eastcoal/shared/enums/ApplicationType'

import { ModeType } from '../types/build'

export type SystemConfiguration = {
  env: {
    /**
     * 应用名称
     */
    appName: undefined | 'operation' | 'member' | 'mall'

    /**
     * 应用类型
     */
    appType: undefined | ApplicationType

    /**
     * 当前系统版本号
     */
    appVersion: string

    /**
     * 构建模式
     */
    mode: ModeType

    /**
     * 是否是生产环境
     */
    isProd: boolean
  }
  api: {
    /**
     * api 网关地址
     */
    baseURL: string

    /**
     * 请求超时时间
     */
    timeout?: number

    /**
     * 是否忽略 401 状态码
     */
    ignore401: boolean
  }
  router: {
    /**
     * 后台管理系统地址
     */
    operationBaseUrl: string
    /**
     * 会员中心地址
     */
    memberBaseUrl: string
    /**
     * 商城系统地址
     */
    mallBaseUrl: string

    /**
     * 帮助中心地址
     */
    supportBaseUrl: string

    /**
     * 登录页面地址
     */
    loginUrl: string
    /**
     * 不用登陆也能访问的页面，仅仅用于前端探测到 http 401 状态时的处理方式
     */
    whitelist: string[]
  }
  webOffice: {
    serverUrl: string
    appId: string
  }
}

export type SystemConfigurer = {
  init: (value: SystemConfiguration) => void
  setter: {
    message: typeof message.config
    notification: typeof notification.config
  }
}

/**
 * 各个业务模块需要注入的系统配置
 */
export const system: SystemConfiguration & SystemConfigurer = {
  init(value) {
    merge(system, value)
  },
  setter: {
    message: message.config,
    notification: notification.config
  },
  env: {
    appName: undefined,
    appType: undefined,
    appVersion: '',
    mode: '' as ModeType,
    isProd: false
  },
  api: {
    baseURL: '',
    timeout: 20000,
    ignore401: false
  },
  router: {
    operationBaseUrl: '',
    memberBaseUrl: '',
    mallBaseUrl: '',
    supportBaseUrl: '',
    loginUrl: '',
    whitelist: [] as string[]
  },
  webOffice: {
    serverUrl: '',
    appId: ''
  }
}
